export interface IUploadFileRequest {
    fileData: string;
    fileExtension: string;
}

export class UploadFileRequest implements IUploadFileRequest {
    fileData: string;
    fileExtension: string;

    constructor(fileData: string, fileExtension: string){
        this.fileData = fileData;
        this.fileExtension = fileExtension;
    }
}